import { Component } from 'react';
import SwipeableViews from "react-swipeable-views";
import EquipmentEPI from '../../components/EPI/EquipmentEPI'
import withAuth from '../../components/withAuth';
import {compose} from "redux";
import {connect} from "react-redux";
import { setEquipmentsEPIIndex, getFiltersInstance } from "../../redux/epi/epiActions";
import './FollowupEquipmentsEPI.css';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "@mui/material/Button";

const midRangeSize = 10;

class EquipmentsEPIPreview extends Component {
    constructor(props) {
		super(props);

		this.state = {
			views: [],
            bottomIndex: 0,
            topIndex: 0
		};

        if (this.props.equipmentsEPI && typeof this.props.epiIndex === "number") {
            if (this.props.epiIndex - midRangeSize > 0) {
                this.state.bottomIndex = this.props.epiIndex - midRangeSize;
            }

            if (this.props.epiIndex + midRangeSize < this.props.equipmentsEPI.length) {
                this.state.topIndex = this.props.epiIndex + midRangeSize;
            } else {
                this.state.topIndex = this.props.equipmentsEPI.length;
            }

            var list = this.props.equipmentsEPI.slice(this.state.bottomIndex, this.state.topIndex);

            list.forEach((element, i) => {
                let index = i + 1 + this.state.bottomIndex ;         
                this.state.views.push(<EquipmentEPI key={index} index={index} equipmentsEPICount={this.props.equipmentsEPI.length} equipmentEPI={element}/>)
            });
        } 
	}

    decreaseIndex = () => {
        if (this.props.epiIndex > 0) {
            let newEpiIndex = this.props.epiIndex - 1;
            if (newEpiIndex == this.state.bottomIndex) {
                let newBottomIndex = this.state.bottomIndex - midRangeSize;
                if (newBottomIndex < 0) {
                    newBottomIndex = 0;
                }

                var list = this.props.equipmentsEPI.slice(newBottomIndex, newEpiIndex);
                var newElements = [];                
                list.forEach((element, i) => {
                    let index = i + 1 + newBottomIndex ;         
                    newElements.push(<EquipmentEPI key={index} index={index} equipmentsEPICount={this.props.equipmentsEPI.length} equipmentEPI={element}/>)
                });

                var newViews = newElements.concat(this.state.views);
                this.setState({views: newViews});  
                this.setState({bottomIndex: newBottomIndex});              
            }
            this.props.setEquipmentsEPIIndex(newEpiIndex);
        }
    };

    increaseIndex = () => {
        if (this.props.epiIndex < this.props.equipmentsEPI.length - 1) {
            let newEpiIndex = this.props.epiIndex + 1;
            if (newEpiIndex == this.state.topIndex - 1) {
                let newTopIndex = this.state.topIndex + midRangeSize;
                if (newTopIndex > this.props.equipmentsEPI.length) {
                    newTopIndex = this.props.equipmentsEPI.length;
                }

                var list = this.props.equipmentsEPI.slice(this.state.topIndex, newTopIndex);
                var newElements = [];                
                list.forEach((element, i) => {
                    let index = i + 1 + this.state.topIndex ;         
                    newElements.push(<EquipmentEPI key={index} index={index} equipmentsEPICount={this.props.equipmentsEPI.length} equipmentEPI={element}/>)
                });

                var newViews = this.state.views.concat(newElements);
                this.setState({views: newViews});
                this.setState({topIndex: newTopIndex});
            }
            this.props.setEquipmentsEPIIndex(newEpiIndex);
        }
    };

    handleChangeIndex = (index) => {
        this.props.setEquipmentsEPIIndex(index);
    };

    render() {           
        let buttons = this.props.equipmentsEPI.length > 1 ? 
            <div className='div-buttons-container'>  
                <Button
                    color="primary"
                    variant="contained"
                    aria-label="Back"
                    onClick={this.decreaseIndex}
                    disabled={!this.props.epiIndex}
                    className="col-lg-6 col-md-6 col-sm-6 col-6"
                >
                    <ArrowBackIcon />
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    aria-label="Forward"
                    onClick={this.increaseIndex}
                    disabled={this.props.epiIndex === this.props.equipmentsEPI.length - 1}
                    className="col-lg-6 col-md-6 col-sm-6 col-6"
                >
                    <ArrowForwardIcon />
                </Button>
            </div>
        : null;

        return (
            (this.state.views.length > 0 ?
            <div  className="main-div">
                <SwipeableViews
                    axis="x"
                    index={this.props.epiIndex - this.state.bottomIndex}
                    onChangeIndex={this.handleChangeIndex}
                >
                    {this.state.views}
                </SwipeableViews>
                {buttons}                
            </div> : null)
        )
    }
}

const mapStateToProps = (state) => {
    return {
        epiIndex: state.equipmentsEPI.epiIndex,
        equipmentsEPI: state.equipmentsEPI.filteredEquipmentsEPI,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEquipmentsEPIIndex: (index) => dispatch(setEquipmentsEPIIndex(index)),
        getFiltersInstance: (myEquipmentsEPI, coworkersEquipmentsEPI) => dispatch(getFiltersInstance(myEquipmentsEPI, coworkersEquipmentsEPI)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(EquipmentsEPIPreview);
